import { render, staticRenderFns } from "./previewDoc.vue?vue&type=template&id=470f2321&scoped=true"
import script from "./previewDoc.vue?vue&type=script&lang=js"
export * from "./previewDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f2321",
  null
  
)

export default component.exports